/**
 * @file 常量 - URL
 * @author hardylin <hardylin@tencent.com>
 */
export default {
  CDN: `${location.protocol}//tiem-cdn.qq.com/slugteam/components/antd`,
  ENV: location.hostname.match(/\.(oa|qq)\./)[0],
}
